<template>
  <Transition appear>
    <div v-if="active" class="cookie-notice">
      <p>
        Our website uses cookies to give you the best user experience on our
        website and to help us deliver our services. By using our services, you
        agree to our use of cookies.
      </p>

      <div>
        <router-link class="app-btn" :to="{ name: 'cookies' }">
          Info
        </router-link>
      </div>

      <button type="button" @click="close">
        <FaIcon :icon="faXmark" />
      </button>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import FaIcon from '@/components/FaIcon.vue';

const active = ref(false);

onMounted(() => {
  active.value = !localStorage.getItem('cookie-notice-accepted');
});

function close() {
  localStorage.setItem('cookie-notice-accepted', 'true');
  active.value = false;
}
</script>

<style lang="scss" scoped>
$notice-main-color: #64a681;

.cookie-notice {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #5700b7;
  color: white;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 40px 10px rgba(0, 0, 0, 0.2);
  transform: translateY(0);
  opacity: 1;
  transition: transform 0.5s;

  p {
    margin: 0 40px 0 0;
  }

  div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-shrink: 0;
  }

  &.v-leave-from {
    animation-delay: 0s;
    animation: slideOutDown 0.1s ease-out both;
  }

  &.v-enter-from {
    transform: translateY(100%);
  }
}

button {
  z-index: 1;
  position: absolute;
  width: 40px;
  height: 40px;
  top: 0;
  right: 0;
  background: transparent !important;
  color: #ffffffc9;
  transform: scale(1);
  transition: 0.25s;

  &:hover {
    color: white;
    transform: scale(1.3);
  }
}

@media screen and (max-width: $mobile-screen-size) {
  .cookie-notice {
    bottom: 0;
    padding: 30px 20px 20px;
    flex-direction: column;
    border-radius: 0;
    width: 100%;
    animation: slideInUp 0.25s both;

    p {
      margin: 0 0 20px;
      text-align: center;
    }

    button.circle-button.floating {
      right: 0;
      left: 0;
      top: -20px;
      margin: 0 auto;
    }
  }
}
</style>
